import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const About = () => {
  return (
    <Box>
      <Typography variant="h3" gutterBottom className="vintage-script-header">
        About Agritur
      </Typography>
      
      <Paper sx={{
        p: 3,
        background: 'transparent',
        border: '2px solid var(--color-border-vintage)',
        borderRadius: 0,
        boxShadow: 'none',
        position: 'relative',
        mb: 3
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, var(--color-accent-gold) 0%, transparent 50%, var(--color-accent-gold) 100%)'
        }}></div>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Agritur is your digital companion for modern gardening, inspired by the timeless wisdom 
          found in vintage botanical guides and agricultural texts. Our platform combines the 
          charm of traditional gardening knowledge with the convenience of modern technology.
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Whether you're a seasoned gardener or just beginning your journey, Agritur provides 
          the tools and knowledge you need to cultivate a thriving garden. From crop planning 
          and soil management to seasonal guides and garden organization, we're here to help 
          you grow.
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Our vintage-inspired interface pays homage to the beautiful botanical illustrations 
          and detailed gardening guides that have guided gardeners for generations, while 
          providing the modern functionality you need for successful garden management.
        </Typography>
      </Paper>

      <Typography variant="h5" sx={{
        fontFamily: 'var(--font-decorative)',
        color: 'var(--color-sepia)',
        mb: 2
      }}>
        Version Information
      </Typography>
      
      <Typography variant="body2" sx={{
        fontFamily: 'var(--font-serif)',
        color: 'var(--color-ink)',
        lineHeight: 1.5
      }}>
        Agritur Garden Manager v1.0.0<br />
        Built with modern web technologies and inspired by vintage botanical artistry.
      </Typography>
    </Box>
  );
};

export default About;
